
const priceNoFractionDigits = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',

	// These options are needed to round to whole numbers if that's what you want.
	minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
export default class Utils {
	static filterText(text: string) {
		if (text) {
			text = text
				.replace('<br>', '\r')
				.replace('/&lt;br/&gt;', '\r')
				.replace('</p>', '')
				.replace('<br>', '\r')
				.replace(/(?:\r\n|\r|\n|\\r|\\n)/gi, '<br>');
			return text;
		}
		return '';
	}

	static removeHtml(text: string) {
		if (text) {
			//console.log('before: '+text)
			text = text.replace(/<\/?[^>]+(>|$)/g, "");
			//console.log('after: '+text)
			return text;
		}
		return '';
	}

	static formatCurrency(numberToFormat: any) {
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
		});

		return formatter.format(numberToFormat)
	}

	static calculateDiscount(price: any, percentage: any) {
		var pct = percentage / 100;
		var pctCal = 1 - pct;
		var calculateDiscount = price/pctCal;
		return (calculateDiscount).toFixed(2);
	}

	static formatPriceNoFractionDigits(numberToFormat: any) {
		return priceNoFractionDigits.format(numberToFormat)
	}

  static parseDateOnly(dateStr?: string | null, options?: { utc?: boolean }): Date | null {
    if (!dateStr || typeof dateStr !== 'string') return null;

    const parts = dateStr.trim().split('-');
    if (parts.length !== 3) return null;

    const [yRaw, mRaw, dRaw] = parts;
    // Allow leading/trailing spaces, guard against NaN
    const y = Number(yRaw);
    const m = Number(mRaw);
    const d = Number(dRaw);

    if (![y, m, d].every(Number.isFinite)) return null;
    if (m < 1 || m > 12 || d < 1 || d > 31) return null; // basic sanity — not full calendar validation

    if (options && options.utc) {
      return new Date(Date.UTC(y, m - 1, d));
    }

    // local midnight
    return new Date(y, m - 1, d);
  }
/*
  static sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }*/

}
